import { library } from '@fortawesome/fontawesome-svg-core';

import {
    faUserSecret, faChevronCircleDown, faChevronCircleRight, faSpinner, faTimes,
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'vue-slim-tabs/themes/default.css';
import VModal from 'vue-js-modal';

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App.vue';
import store from './store';
import router from './router';
import vuetify from './plugins/vuetify';
import { lang as enlang } from './locale/en';

const appConf = require('./aws-configuration');

Vue.prototype.$config = appConf;

library.add(faUserSecret, faChevronCircleDown, faChevronCircleRight, faTimes, faSpinner);
Vue.component('FontAwesomeIcon', FontAwesomeIcon);
Vue.use(VModal);
Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'en', // set locale
    fallbackLocale: 'en',
    messages: {
        en: enlang,
    },
});

Vue.config.productionTip = false;
Vue.config.devtools = appConf.stage !== 'production';

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
}).$mount('#app');
